<template>
  <div class="research-report-digest">
    <MoreTitle title="研报摘要" />
    <div class="edge-width-padding">
      <InfoList :data="reportData" :busy="busy" @to="goPage">
        <template #bottom="{ item }">
          <div class="bottom-wrap">
            <span class="invest">{{ $digitjs(item.invest).isNull() }}</span>
            <span class="source">{{ $digitjs(item.source).isNull() }}</span>
            <span class="time">{{ $digitjs(item.reportDate).isNull() }}</span>
          </div>
        </template>
      </InfoList>
      <LoadMoreButton :finished="finished" :loading="loading" />
    </div>
  </div>
</template>

<script>
import InfoList from '@/components/common/info/InfoList.vue'
import LoadMoreButton from '@/components/common/LoadMoreButton.vue'
export default {
  components: { InfoList, LoadMoreButton },
  data() {
    return {
      reportData: [],
      loading: false,
      finished: false
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    busy() {
      return this.loading || this.finished
    }
  },
  created() {
    this.getReportData()
  },
  methods: {
    async getReportData() {
      this.loading = true
      const res = await this.$post(this.$api.f10[this.market] + '/summary/reportdata', {
        symbol: this.symbol,
        startDate: '1970-01-01'
      })
      this.reportData = res.data?.data ?? []
      this.loading = false
      this.finished = true
    },
    goPage(item) {
      const { title, summary, source, reportDate: time } = item
      this.$router.push({
        path: '/report/details',
        query: {
          title,
          content: summary,
          source,
          time,
          symbol: this.symbol
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.research-report-digest {
  background: var(--bg-color-2);
  .bottom-wrap {
    display: flex;
    align-items: center;
    .invest,
    .source {
      margin-right: 8px;
    }

    .invest {
      padding: 2px 5px;
      text-align: center;
      line-height: 18px;
      border-radius: 4px;
      font-size: 12px;
      color: #ff9933;
      background: #fff4eb;
    }
  }
}
</style>
